import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { toast } from "sonner";
import { AuthShell, GoogleButton } from "@/components/AuthShell";

export default function Login() {
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", form);
      loginWithToken(data.token, data.user);
      toast.success("Bienvenue !");
      if (data.user.role === "admin") navigate("/admin");
      else navigate(data.user.onboarded ? "/dashboard" : "/onboarding");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Échec de la connexion");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Connexion" subtitle="Accédez à votre studio publicitaire IA.">
      <form onSubmit={submit} className="space-y-4">
        <div>
          <Label htmlFor="email">E-mail</Label>
          <Input id="email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1.5 h-11 rounded-xl" placeholder="vous@marque.com" data-testid="login-email" />
        </div>
        <div>
          <Label htmlFor="password">Mot de passe</Label>
          <Input id="password" type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="mt-1.5 h-11 rounded-xl" placeholder="••••••••" data-testid="login-password" />
        </div>
        <Button type="submit" disabled={loading} className="w-full h-11 rounded-xl bg-gradient-to-r from-indigo-500 to-cyan-500 text-white border-0" data-testid="login-submit">
          {loading ? "Connexion…" : "Se connecter"}
        </Button>
      </form>

      <div className="flex items-center gap-3 my-5">
        <div className="h-px flex-1 bg-border" />
        <span className="text-xs text-muted-foreground">ou</span>
        <div className="h-px flex-1 bg-border" />
      </div>

      <GoogleButton label="Continuer avec Google" />

      <p className="text-center text-sm text-muted-foreground mt-6">
        Pas encore de compte ? <Link to="/register" className="text-primary font-medium hover:underline" data-testid="goto-register">Créer un compte</Link>
      </p>
    </AuthShell>
  );
}
